module.exports = "/src/views/games/other/images/maps/map_2.png";